export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9706.75ce286d.jpg";